import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />

      <main>
        <Hero />

        <TopicsSection />

        <IndexSection />

        <FaqSection />

        <AboutSection />

        <RankingSection />

        <CarouselSection />

        <CommentsSection />

        <FeaturesSection />

        <MediaSection />

        <ContactSection />

        <UpdatesSection />

        <CardsSection />

        <AppSection />
      </main>

      <Footer />
    </>
  );
}